import React, { useState } from 'react';
import classNames from 'classnames';

import { OrderSideEnum } from '../../../../../lib/enums';
import lang from '../../../../../lib/language';
import SymbolStatusCache from '../../../../../lib/store-util/SymbolStatusCache';
import { CalculatedSymbolPrices } from '../../../../../lib/util/ChartingHelpers';
import { formatCurrency } from '../../../../../lib/util/DataHelpers';
import { checkIfSymbolIsHalted } from '../../../../../lib/util/HaltSymbolHelper';
import { useMarketStateInfo } from '../../../../../lib/util/hooks/market/MarketStateInfoHook';

import { useIsMobile } from '../../../../../hooks';
import { Button, CapitalBuySellButtonsConditions } from '../../../..';
import HaltedSymbol from '../../../../OrderActions/HaltedSymbol/HaltedSymbol';
import { getChangeStyle } from '../../../getChangeStyle';
import { priceChange } from '../helpers';

import ExtraPriceInfo from './ExtraPriceInfo';
import InfoStatus from './InfoStatus';

import styles from '../ChartHeader.module.scss';

type OwnProps = {
  symbol: string;
  companyName?: string;
  handleCreateOrderSellOrBuy: (target: string, isHeaderBtn: boolean) => void;
};
type Props = OwnProps & CalculatedSymbolPrices;

const MainPriceInfo = (props: Props): JSX.Element => {
  const {
    currentMainPrice,
    changeMainPrice,
    changedPercentMainPrice,
    mainPriceDirection,
    hasAfterMarketData,
    symbol,
    companyName,
    handleCreateOrderSellOrBuy,
  } = props;
  const isMobile = useIsMobile();
  const symbolStatus = SymbolStatusCache.use(symbol);
  const [isSymbolHalted, setIsSymbolHalted] = useState<boolean>(false);

  const noChangeData = changedPercentMainPrice == null;
  const changeStyle = getChangeStyle(mainPriceDirection);

  const priceChangeStyle = classNames(
    styles.mainPriceChange,
    { [styles.mainPriceChangeHidden]: noChangeData },
  );
  const { status: infoType } = useMarketStateInfo(!!hasAfterMarketData);
  const handleClickButtonSellOrBuy = (target: string) => {
    if (checkIfSymbolIsHalted(symbolStatus)) {
      setIsSymbolHalted(true);
    } else {
      handleCreateOrderSellOrBuy(target, true);
    }
  };

  const showRestrictionsModals = (): JSX.Element => {
    if (isSymbolHalted) {
      return (<HaltedSymbol symbolName={companyName ?? symbol} toggleModal={() => setIsSymbolHalted(false)} />);
    }
    return (< > </>);
  };

  return (
    <>
      {showRestrictionsModals()}
      <div className={isMobile ? styles.wrapperPriceHeaderMobile : styles.wrapperPriceHeader}>
        {currentMainPrice ? (
          <div>
            {isMobile ? (
              <span className={styles.mainPriceMobile}>
                { formatCurrency(currentMainPrice) }
              </span>
            ) : (
              <span className={styles.mainPrice}>
                { formatCurrency(currentMainPrice) }
              </span>
            )}
            <span className={priceChangeStyle} style={changeStyle}>
              { priceChange(changeMainPrice, changedPercentMainPrice) }
            </span>
            <InfoStatus type={infoType} />
            <ExtraPriceInfo {...props} />
          </div>
        ) : (
          <div className={styles.loadingArea}>
            <div className={styles.priceLoader} />
            <div className={styles.priceLoader} />
          </div>
        )}
        {
        !isMobile
        && (
          <div className={styles.wrapperButtons}>
            <CapitalBuySellButtonsConditions>
              <>
                <Button
                  className={styles.btnSell}
                  onClick={() => handleClickButtonSellOrBuy(OrderSideEnum.Sell)}
                >
                  {lang.mobileTradingTicketSell()}
                </Button>
                <Button
                  className={styles.btnBuy}
                  onClick={() => handleClickButtonSellOrBuy(OrderSideEnum.Buy)}
                >
                  {lang.mobileTradingTicketBuy()}
                </Button>
              </>
            </CapitalBuySellButtonsConditions>
          </div>
        )
      }
      </div>
    </>
  );
};

export default MainPriceInfo;
